import React, { useState } from "react";
import { MDBBox, MDBCol, MDBRow } from "mdbreact";
import { Button, Text, TextInput } from "evergreen-ui";
import { v4 as uuidv4 } from 'uuid';

const UserRolesActionLayout = (props) => {

	const [roleName, setRoleName] = useState(null);
	const [roleDescription, setRoleDescription] = useState(null);

	const handleCreate = () => {
		if (roleName.includes("/")) {
			alert("the name cannot include a slash, use a dash or another symbol instead")
		} else {
			var objectID = uuidv4();
			var object = {
				"roleName": roleName,
				"description": roleDescription,
				"id": objectID,
			}
			setRoleName("");
			props.createCallback("userRoles", objectID, object);
		}
	}

	return (
		<div className="font-Nunito">
			<MDBBox>
				<MDBRow>
					<MDBRow>
						<div className="pl-4">
							<MDBCol>
								<div className="d-flex flex-column">
									<Text className=" mb-1">Enter Role Name</Text>
									<TextInput
										name="text-input-name"
										placeholder="enter role name"
										onChange={(e) => { setRoleName(e.target.value) }}
										value={roleName}
									/>
								</div>
								<div className="d-flex flex-column">
									<Text className=" mb-1">Role Description</Text>
									<TextInput
										name="text-input-description"
										placeholder="Descriptions"
										row={3}
										multiple
										onChange={(e) => { setRoleDescription(e.target.value) }}
										value={roleDescription}
									/>
								</div>
								<div>
									<Button appearance="primary" className="mt-3" onClick={() => {
										handleCreate();
									}}>Add</Button>
								</div>
							</MDBCol>
						</div>
					</MDBRow>
				</MDBRow>
			</MDBBox>
		</div>
	)
}

export default UserRolesActionLayout;
